import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getDomain } from '../utils/getDomain';

function Header() {
  const domain = getDomain();
  const domainName = domain.split('.')[0]; // e.g., "vpn111" from "vpn111.com"
  const location = useLocation();
  const navigate = useNavigate();
  const isSignupPage = location.pathname === '/signup';

  // Function to close mobile menu
  const closeMobileMenu = () => {
    const menuBtn = document.querySelector('.mobile-menu-btn');
    const header = document.querySelector('header');
    const body = document.body;
    
    if (menuBtn && header && body) {
      menuBtn.classList.remove('active');
      header.classList.remove('active');
      body.classList.remove('mobile-menu-open');
    }
  };

  // Handle mobile menu link clicks
  const handleMobileLinkClick = (e, href) => {
    // Close the mobile menu first
    closeMobileMenu();
    
    // If it's an anchor link (starts with #), handle scrolling
    if (href && href.includes('#')) {
      e.preventDefault();
      
      // If it's a full URL with anchor (like /#pricing)
      if (href.startsWith('/#')) {
        const anchor = href.substring(2); // Get 'pricing' from '/#pricing'
        
        // If we're not on the home page, navigate first
        if (location.pathname !== '/') {
          navigate('/');
          // Wait for navigation and DOM to be ready, then scroll
          // Use a longer timeout and retry mechanism
          const scrollToAnchor = () => {
            const element = document.getElementById(anchor);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
              // Retry after a short delay if element not found yet
              setTimeout(scrollToAnchor, 50);
            }
          };
          setTimeout(scrollToAnchor, 300);
        } else {
          // We're already on home page, just scroll after menu closes
          setTimeout(() => {
            const element = document.getElementById(anchor);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 200);
        }
      } else if (href.startsWith('#')) {
        // Just an anchor link
        e.preventDefault();
        const anchor = href.substring(1);
        setTimeout(() => {
          const element = document.getElementById(anchor);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 200);
      }
    }
  };
  
  return (
    <header className="main" style={{marginBottom: '0px !important', paddingBottom: '20px !important'}}>
      <div className="container">
        <div className="row">
          <div className="col-md-2">
            <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
                <img src="/images/logo.svg" alt="logo" className="logo-icon" />
                <span className="logo-brand-text">{domainName.toUpperCase()}</span>
              </Link>
            </div>
          </div>
          <div className="col-md-7">
            <ul className="menu">
              <li><a href="/#pricing">Pricing</a></li>
              <li><Link to="/guide">Guide</Link></li>
              <li><Link to="/feature">Features</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          <div className="col-md-3">
            <div className="button-header">
              <a href="/login" className="custom-btn login">Login</a>
              {!isSignupPage && (
                <Link to="/signup" className="custom-btn">Sign Up</Link>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-block">
        <div className="logo-mobile">
          <Link to="/" className="logo-mobile-link" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
            <img src="/images/logo.svg" alt="logo" className="logo-mobile-img logo-icon" />
            <span className="logo-mobile-text logo-brand-text">{domainName.toUpperCase()}</span>
          </Link>
        </div>
        <a href="#" className="mobile-menu-btn"><span></span></a>
        <div className="mobile-menu">
          <div className="inside">
            <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Link to="/" className="logo-mobile-link" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
                <img src="/images/logo.svg" alt="logo" className="logo-mobile-img logo-icon" />
                <span className="logo-mobile-text logo-brand-text">{domainName.toUpperCase()}</span>
              </Link>
            </div>
            <ul className="menu panel-group" id="accordion" aria-multiselectable="true">
              <li>
                <a 
                  href="/#pricing" 
                  onClick={(e) => handleMobileLinkClick(e, '/#pricing')}
                >
                  Pricing
                </a>
              </li>
              <li>
                <Link 
                  to="/guide" 
                  onClick={closeMobileMenu}
                >
                  Guide
                </Link>
              </li>
              <li>
                <Link 
                  to="/feature" 
                  onClick={closeMobileMenu}
                >
                  Features
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  onClick={closeMobileMenu}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
            <div className="button-header">
              <a 
                href="/login" 
                className="custom-btn login"
                onClick={closeMobileMenu}
              >
                Login
              </a>
              {!isSignupPage && (
                <Link 
                  to="/signup" 
                  className="custom-btn"
                  onClick={closeMobileMenu}
                >
                  Sign Up
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
